import { FirebaseApplicant } from "../../../entities/applicant";
import ApplicantRepository from "../../ports/applicantRepository";

export type fetchApplicantsUsecase = (
  limit?: number,
  where?: [string, "<" | "<=" | "==" | ">=" | ">", string | number | boolean][]
) => Promise<FirebaseApplicant[]>;

export const buildFetchApplicants = (dependencies: {
  applicantRepo: ApplicantRepository;
}): fetchApplicantsUsecase => {
  const { applicantRepo } = dependencies;

  const fetchApplicants: fetchApplicantsUsecase = async (
    limit?: number,
    where?: [
      string,
      "<" | "<=" | "==" | ">=" | ">",
      string | number | boolean
    ][]
  ) => applicantRepo.fetchApplicants(limit, where);

  return fetchApplicants;
};
